export default __webpack_public_path__ + "static/brush-after-large-5db19a682509d51f683659e300af86d6.png";